export default __webpack_public_path__ + "static/media/SORT.7175e62d.svg";